<div class="dd-v-spec-page" *ngIf="vehicleDetails?.dealerCategory !== 'H'">
  <dd-vehicle-detail-header [vehicleDetails]="vehicleDetails" [sharedData]="sharedData" [dealerDetails]="dealerDetails" [baseMrspDisclaimer]="baseMsrpDisclaimer" [tsrpDisclaimer]="tsrpDisclaimer" *ngIf="vehicleDetails">
  </dd-vehicle-detail-header>
  <div fxLayout="column" class="dd-gray-backgound" *ngIf="vehicleInfoNotFound">
    <dd-page-not-found [errorText]="vehicleInfoNotFoundMessage" [directionText] = "vehicleInfoNotFoundDirection">
    </dd-page-not-found>
  </div>
  <div fxLayout="column" class="dd-gray-backgound" *ngIf="incompleteVehicle && !vehicleInfoNotFound">
    <dd-page-not-found [errorText]="vehicleInfoIncompleteMessage" [directionText] = "vehicleInfoIncompleteDirection">
    </dd-page-not-found>
  </div>
  <dd-app-menu></dd-app-menu>
  <div fxLayout="column" class="dd-content-margin" *ngIf="vehicleDetails && vehicleInfoNotFound === false">
    <dd-page-title [title]="'Vehicle Details'"></dd-page-title>
  </div>
  <div fxLayout="column" fxLayoutGap="10px" *ngIf="vehicleDetails && vehicleInfoNotFound === false">
  <div fxLayout.gt-sm="row" fxLayout="column" fxLayoutGap="30px" class="dd-content-margin dd-price-container">
  </div>

    <!-- <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="start center" fxLayoutAlign.xs="center start"
      fxLayoutGap.xs="20px" class="dd-content-margin" style="padding-bottom: 10px;">
      <div fxFlex="50%" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div class="dd-int-ext-color-img" [style.background]="sharedFunctionService.transform('#' + vehicleDetails?.extColor?.colorHexCd)"></div>
        <div fxLayout="column" fxLayoutAlign="space-between start">
          <div>EXTERIOR COLOR</div>
          <div class="dd-color-text">{{vehicleDetails?.extColor?.marketingName}}</div>
        </div>
      </div>
      <div fxFlex="50%" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div class="dd-int-ext-color-img" [style.background]="sharedFunctionService.transformURL(vehicleDetails?.intColor?.colorSwatch)"
          title="{{vehicleDetails?.intColor?.colorDisplayName}}"></div>
        <div fxLayout="column" fxLayoutAlign="space-between start">
          <div>INTERIOR COLOR</div>
          <div class="dd-color-text" [innerHTML]="vehicleDetails?.intColor?.marketingName">{{vehicleDetails?.intColor?.marketingName}}</div>
        </div>
      </div>
    </div> -->
    <div class="dd-content-margin" *ngIf="vehicleDetails">
      <div class="dd-price-fuel-container">
        <div class="dd-price-container">
          <div class="dd-para-title">
            <span *ngIf="!dealerDetails?.isLexus" class="dd-title-text">PRICE</span>
          </div>
          <div class="dd-para-title">
            <span *ngIf="dealerDetails?.isLexus" class="dd-title-text-lexus">PRICE</span>
          </div>
          <div class="dd-base-model">
              <div class="dd-opt-header-text">{{dealerDetails?.isLexus ? 'Vehicle Base Model (MSRP *)' : 'Base MSRP *'}}</div>
              <div class="dd-opt-value" *ngIf="vehicleDetails?.price?.baseMsrp !== 'N/A'">{{ vehicleDetails?.price?.baseMsrp | currency: 'USD': true: '1.2'}}</div>
              <div class="dd-opt-value" *ngIf="vehicleDetails?.price?.baseMsrp === 'N/A'">N/A</div>
          </div>
          <div class="dd-line dd-price-line" *ngIf="factoryaccessoriesTotalPrice != 0"></div>
          <div class="dd-base-model" *ngIf="factoryaccessoriesTotalPrice != 0">
            <div class="dd-opt-header-text">Factory Installed Packages & Accessories</div>
            <div class="dd-opt-value">{{ factoryaccessoriesTotalPrice | currency: 'USD': true: '1.2' }}</div>
        </div>
        <div class="dd-line dd-price-line" *ngIf="distributoraccessoriesTotalPrice != 0"></div>
        <div class="dd-base-model" *ngIf="distributoraccessoriesTotalPrice != 0">
          <div class="dd-opt-header-text">Distributor Installed Packages & Accessories</div>
          <div class="dd-opt-value">{{ distributoraccessoriesTotalPrice | currency: 'USD': true: '1.2'}}</div>
      </div>
      <div class="dd-line dd-price-line" *ngIf="dealerInstalledaccessoriesTotalPrice != 0"></div>
      <div class="dd-base-model" *ngIf="dealerInstalledaccessoriesTotalPrice != 0">
        <div class="dd-opt-header-text">Dealer Installed Packages & Accessories</div>
        <div class="dd-opt-value">{{ dealerInstalledaccessoriesTotalPrice | currency: 'USD': true: '1.2'}}</div>
    </div>
    <div class="dd-line dd-price-line" *ngIf="portaccessoriesTotalPrice != 0"></div>
          <div class="dd-base-model" *ngIf="portaccessoriesTotalPrice != 0">
            <div class="dd-opt-header-text">Port Installed Packages & Accessories</div>
            <div class="dd-opt-value">{{ portaccessoriesTotalPrice | currency: 'USD': true: '1.2' }}</div>
        </div>
          <div class="dd-line dd-price-line"></div>
          <div class="dd-base-model">
              <div class="dd-opt-header-text">Delivery Processing and Handling</div>
              <div class="dd-opt-value" *ngIf="vehicleDetails?.price?.dph !== 'N/A'">{{ vehicleDetails?.price?.dph | currency: 'USD': true: '1.2'}}</div>
              <div class="dd-opt-value" *ngIf="vehicleDetails?.price?.dph === 'N/A'">N/A</div>
          </div>
          <div class="dd-line dd-price-line" *ngIf="isSmartPathDealer && isOwningDealer && dealerAdjustments !== 0"></div>
          <div class="dd-base-model" *ngIf="isSmartPathDealer && isOwningDealer && dealerAdjustments !== 0">
              <div class="dd-opt-header-text">Dealer Adjustments</div>
              <div class="dd-opt-value">{{ dealerAdjustments | currency: 'USD': true: '1.2'}} </div>
          </div>
          <div class="dd-line dd-price-line" *ngIf="isSmartPathDealer"></div>
          <div *ngIf="isSmartPathDealer" class="dd-total-msrp">
              <div [ngClass] = "{'dd-msrp-total-lexus': vehicleDetails?.brand === 'LEXUS','dd-msrp-total-red': vehicleDetails?.brand !== 'LEXUS'}">Total Advertised Price</div>
              <div *ngIf="isOwningDealer && vehicleDetails?.price?.advertizedPrice && vehicleDetails?.price?.advertizedPrice !== 'N/A'" [ngClass] = "{'dd-msrp-total-lexus': vehicleDetails?.brand === 'LEXUS','dd-msrp-total-red': vehicleDetails?.brand !== 'LEXUS'}">{{ vehicleDetails?.price?.advertizedPrice | currency: 'USD': true:
                '1.2'
              }}</div>
              <div class="dd-opt-value" *ngIf="vehicleDetails?.price?.advertizedPrice === 'N/A' && vehicleDetails?.price?.totalMsrp === 'N/A'">N/A</div>
              <div *ngIf="(!isOwningDealer || (!vehicleDetails?.price?.advertizedPrice || vehicleDetails?.price?.advertizedPrice === 'N/A')) && 
              vehicleDetails?.price?.totalMsrp && vehicleDetails?.price?.totalMsrp !== 'N/A'" [ngClass] = "{'dd-msrp-total-lexus': vehicleDetails?.brand === 'LEXUS','dd-msrp-total-red': vehicleDetails?.brand !== 'LEXUS'}">{{ vehicleDetails?.price?.totalMsrp | currency: 'USD': true:
                '1.2'
              }}</div>
            </div>
            <div class="dd-line dd-price-line" *ngIf="!isSmartPathDealer"></div>
            <div *ngIf="!isSmartPathDealer" class="dd-total-msrp">
              <div [ngClass] = "{'dd-msrp-total-lexus': vehicleDetails?.brand === 'LEXUS','dd-msrp-total-red': vehicleDetails?.brand !== 'LEXUS'}">{{ isGST || dealerDetails?.isLexus ? 'Total Price' : 'Total Suggested Retail Price'}}</div>
              
              <div class="dd-opt-value" *ngIf="vehicleDetails?.price?.totalMsrp === 'N/A'">N/A</div>
              <div *ngIf="vehicleDetails?.price?.totalMsrp !== 'N/A'" [ngClass] = "{'dd-msrp-total-lexus': vehicleDetails?.brand === 'LEXUS','dd-msrp-total-red': vehicleDetails?.brand !== 'LEXUS'}">{{ vehicleDetails?.price?.totalMsrp | currency: 'USD': true:
                '1.2'
                }}</div>
          </div>
        </div>
        <!-- <div class="dd-separator-space">
          &nbsp;
        </div> -->
        <div class="dd-fuel-container">
          <div class="dd-price-container">
            <div class="dd-para-title">
              <span *ngIf="!dealerDetails?.isLexus" class="dd-title-text">FUEL ECONOMY</span>
            </div>
            <div class="dd-para-title">
              <span *ngIf="dealerDetails?.isLexus" class="dd-title-text-lexus">FUEL ECONOMY</span>
            </div>
            <div class="dd-fuel-economy-container">
                <div class="dd-fuel-comcombed-container">
                  <table>
                    <tr>
                      <td *ngIf = "isGas || isHybrid">
                        <img src="./assets/icons/Gas-pump.svg">
                      </td>
                      <td *ngIf="isGas || isHybrid">
                        <!-- Gas or Hybrid vehicle  -->
                        <label class="dd-fuel-combined">{{mpgDetails?.mpg?.combined}}</label>
                        <label class="dd-fuel-mpg-text">MPG</label>
                      </td>
                    </tr>
                    <tr *ngIf="isGas">
                      <!-- Gas vehicle  -->
                      <td colspan="2">
                        <label class="dd-fuel-combined-city-hway-text">Combined City / Hwy</label>
                      </td>
                    </tr>

                  </table>
                </div>
                <div [class.dd-fuel-city-container]="mpgDetails?.combined">
                  <table>
                    <tr>
                      <td *ngIf="isHybrid || isElectric">
                        <!-- Hybrid vehicle  -->
                        <img src="./assets/icons/Hybrid-gas-pump.svg" style="height: 53px; padding-left: 30px;;">
                      </td>
                      <td *ngIf="isHybrid">
                        <!-- Hybrid vehicle  -->
                        <label class="dd-fuel-combined">{{mpgDetails?.mpge?.combined}}</label>
                        <label class="dd-fuel-mpg-text">&nbsp;MPGe</label>
                      </td>
                      <td *ngIf="isElectric">
                        <!-- Electric vehicle  -->
                        <label class="dd-fuel-combined">{{mpgDetails?.range}}</label>
                        <label class="dd-fuel-mpg-text">&nbsp;mi</label>
                      </td>
                    </tr>
                    <tr *ngIf="isElectric">
                      <!-- Electric vehicle  -->
                      <td colspan="2" class="dd-fuel-range">
                        <label class="dd-fuel-combined-city-hway-text">Range</label>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="dd-city-hway-container" *ngIf="isGas">
                  <!-- Gas vehicle  -->
                  <table>
                    <tr>
                      <td>
                        <label class="dd-fuel-city-hway-title">
                          {{mpgDetails?.mpg?.cityMpg}}</label>
                        <label class="dd-fuel-mpg-text">&nbsp;MPG</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label class="dd-fuel-economy">City</label>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="dd-city-hway-container" *ngIf="isElectric">
                  <!-- Electric vehicle  -->
                  <table>
                    <tr>
                      <td>
                        <label class="dd-fuel-city-hway-title">
                          {{mpgDetails?.mpge?.cityMpge}}</label>
                        <label class="dd-fuel-mpg-text">&nbsp;MPGe</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label class="dd-fuel-economy">City</label>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="dd-city-hway-container" *ngIf="isGas">
                  <!-- Gas vehicle  -->
                  <table>
                    <tr>
                      <td>
                        <label class="dd-fuel-city-hway-title">
                          {{mpgDetails?.mpg?.highwayMpg}}</label>
                        <label class="dd-fuel-mpg-text">&nbsp;MPG</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label class="dd-fuel-city-hway-text">Highway</label>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="dd-city-hway-container" *ngIf="isElectric">
                  <!-- Electric vehicle  -->
                  <table>
                    <tr>
                      <td>
                        <label class="dd-fuel-city-hway-title">
                          {{mpgDetails?.mpge?.highwayMpge}}</label>
                        <label class="dd-fuel-mpg-text">&nbsp;MPGe</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label class="dd-fuel-city-hway-text">Highway</label>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dd-content-margin" *ngIf="vehicleDetails">
      <div class="dd-int-ext-color-container">
        <div class="dd-ext-color-container">
          <div class="dd-ext-ext-color-img" [style.background]="vehicleDetails?.brand !== 'LEXUS' ? sharedFunctionService.transform('#' + vehicleDetails?.extColor?.colorHexCd):sharedFunctionService.transformURL(vehicleDetails?.extColor?.colorSwatch)"></div>
          <div class="dd-ext-color-text-container">
            <div class="dd-color-title">EXTERIOR COLOR</div>
            <div class="dd-color-text" [innerHTML]="vehicleDetails?.extColor?.marketingName"></div>
          </div>
        </div>
        <!-- <div class="dd-separator-space">
          &nbsp;
        </div> -->
        <div class="dd-int-color-container">
          <div class="dd-int-ext-color-img" [style.background]="sharedFunctionService.transformURL(vehicleDetails?.intColor?.colorSwatch)"
            title="{{vehicleDetails?.intColor?.colorDisplayName}}"></div>
          <div class="dd-int-color-text-container">
            <div class="dd-color-title">INTERIOR COLOR</div>
            <div class="dd-color-text" [innerHTML]="vehicleDetails?.intColor?.marketingName"></div>
          </div>
        </div>
      </div>
    </div>

    <div fxLayout="column" class="dd-content-margin dd-opt-equib-container" inViewport (inViewportAction)="installedOptionsAction($event)">

      <div class="dd-para-title">
        <span *ngIf="!dealerDetails?.isLexus" class="dd-title-text">INSTALLED PACKAGES & ACCESSORIES</span>
      </div>
      <div class="dd-para-title">
        <span *ngIf="dealerDetails?.isLexus" class="dd-title-text-lexus">INSTALLED PACKAGES & ACCESSORIES</span>
      </div>
      <!-- <div class="dd-opt-equib-title">
                <label class="dd-para-head">INSTALLED PACKAGES & ACCESSORIES</label>
              </div> -->
      <div class="dd-fuel-economy"></div>
      <div *ngFor="let opt of vehicleDetails?.options;let i = index">
        <div class="dd-options-container">
            <label class="dd-options-header" [innerHTML]="opt?.marketingName"></label>
            <label class="dd-options-header-type" *ngIf="opt?.optionType === 'F'">FIO</label>
            <label class="dd-options-header-type" *ngIf="opt?.optionType === 'P'">PIO</label>
            <label class="dd-options-header-type" *ngIf="opt?.optionType === 'D'">DIO</label>
            <label class="dd-options-header-type" *ngIf="opt?.optionType === 'L'">LIO</label>
            <label class="dd-options-price">{{ optionsFilter(opt)  }}</label>
        </div>
        <div class="dd-options-body" [innerHTML]="opt?.marketingLongName"></div>
        <div *ngIf="i < vehicleDetails?.options?.length -1" class="dd-line"></div>
      </div>
      <div class="dd-line"></div>
      <div>
        <div class="dd-options-container">
          <label class="dd-options-header">{{ TOTAL_OPTIONAL_EQUIPMENT }}</label>
          <label class="dd-options-price">{{ vehicleDetails?.price?.optTotalMsrp | currency:'USD':'symbol':'1.2-2' }}</label>
        </div>
      </div>
      <div class="dd-line included-price" *ngIf="!(isSmartPathDealer || isGST) && isDios">**** Included in Total Price</div>
      <!-- <div>
                <label class="dd-msrp-total">Total MSRP<sup>*</sup> &nbsp;&nbsp;&nbsp; {{
                    vehicleDetails?.price?.totalMsrp
                    | currency: 'USD': true: '1.2' }}</label>
            </div> -->
    </div>

    <div fxLayout="column" class="dd-standard-equib-container" inViewport (inViewportAction)="featuresAction($event)">
      <div fxLayout="column" class="dd-content-margin">
        <div class="dd-para-title">
          <span *ngIf="!dealerDetails?.isLexus" class="dd-title-text">FEATURES</span>
        </div>
        <div class="dd-para-title">
          <span *ngIf="dealerDetails?.isLexus" class="dd-title-text-lexus">FEATURES</span>
        </div>
        <!-- <div class="dd-standard-equib-title">
          <label class="dd-para-head">FEATURES</label>
        </div>
        <div class="dd-fuel-economy">-->
        <!--<div class="dd-fuel-economy">-->
        <div *ngIf="!dealerDetails?.isLexus" class="dd-fuel-economy">
          <article>
            <ng-container *ngIf = "vehicleDetails?.standardOptions?.mechanicalAndPerformance?.length">
              <label class="dd-section-head-text">Mechanical & Performance</label>
              <ul>
                <li *ngFor="let row of vehicleDetails?.standardOptions?.mechanicalAndPerformance">
                  <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
                </li>
              </ul>
            </ng-container>
            <ng-container *ngIf="vehicleDetails?.standardOptions?.steering?.length">
              <label class="dd-section-head-text">Steering</label>
              <ul>
                <li *ngFor="let row of vehicleDetails?.standardOptions?.steering">
                  <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
                </li>
              </ul>
            </ng-container>
           <ng-container *ngIf="vehicleDetails?.standardOptions?.exterior?.length">
            <label class="dd-section-head-text">Exterior</label>
            <ul>
              <li *ngFor="let row of vehicleDetails?.standardOptions?.exterior">
                <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
              </li>
            </ul>
           </ng-container>
           <ng-container *ngIf= "exteriorLabels?.length">
            <label class="dd-section-head-text">Exterior Dimensions</label>
            <ul>
              <li *ngFor="let row of exteriorLabels">
                <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
              </li>
            </ul>
           </ng-container>
           <ng-container *ngIf="vehicleDetails?.standardOptions?.interior?.length">
            <label class="dd-section-head-text">Interior</label>
            <ul>
              <li *ngFor="let row of vehicleDetails?.standardOptions?.interior">
                <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
              </li>
            </ul>
           </ng-container>
           <ng-container *ngIf="vehicleDetails?.standardOptions?.audioMultimedia?.length">
            <label class="dd-section-head-text">Audio Multimedia</label>
            <ul>
              <li *ngFor="let row of vehicleDetails?.standardOptions?.audioMultimedia">
                <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
              </li>
            </ul>
           </ng-container>
           <ng-container *ngIf="vehicleDetails?.standardOptions?.toyotaCare?.length">
            <label class="dd-section-head-text">ToyotaCare</label>
            <ul>
              <li *ngFor="let row of vehicleDetails?.standardOptions?.toyotaCare">
                <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="vehicleDetails?.standardOptions?.offHighway?.length">
            <label class="dd-section-head-text">Off-Highway</label>
            <ul>
              <li *ngFor="let row of vehicleDetails?.standardOptions?.offHighway">
                <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
              </li>
            </ul>
          </ng-container>
            <ng-container *ngIf="vehicleDetails?.standardOptions?.safetyAndConvenience?.length">
              <label class="dd-section-head-text">Safety and Convenience</label>
              <ul>
                <li *ngFor="let row of vehicleDetails?.standardOptions?.safetyAndConvenience">
                  <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
                </li>
              </ul>
            </ng-container>
            <ng-container *ngIf="vehicleDetails?.standardOptions?.connectedServices?.length">
              <label class="dd-section-head-text">Connected Services</label>
              <ul>
                <li *ngFor="let row of vehicleDetails?.standardOptions?.connectedServices">
                  <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
                </li>
              </ul>
            </ng-container>
          </article>
        </div>
        <div *ngIf="dealerDetails?.isLexus" class="dd-fuel-economy">
          <article>
            <div *ngIf="dealerDetails?.isLexus" class="dd-fuel-economy">
              <label class="dd-section-head-text">Mechanical & Performance</label>
                <ul>
                  <li *ngFor="let row of vehicleDetails?.standardOptions?.mechanicalAndPerformance">
                    <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
                  </li>
                </ul>
            </div>
            <ng-container *ngFor = "let item of vehicleDetails?.standardEquipments">
              <label class="dd-section-head-text"> {{ item.header }}</label>
              <ul>
                <li *ngFor="let row of item.value">
                  <label class="dd-para-body" [innerHTML]="removeSpecialChars(row)"></label>
                </li>
              </ul>
            </ng-container>
          </article>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="center center" class="dd-content-margin dd-download-btn-container">
      <!-- </div>
        <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center" class="dd-content-margin dd-dealer-name-container" style="background-color: #EDF0F5;"> -->
      <div fxLayout="row">
        <dd-dealer-details [dealerDetails]="dealerDetails" [layoutAlign]="'center center'"></dd-dealer-details>
      </div>
      <div>&nbsp;</div>
      <div *ngIf="dealerDetails?.phone">
        <dd-phone-number [phoneNumber]="dealerDetails?.phone" (click)="omTag.fireOmnitureTag('vd_km-dealer-contact-call', {url:'', href: '', text:dealerDetails?.phone, trigger:'km-link'}, sharedData)"></dd-phone-number>
      </div>
      <div>&nbsp;</div>
      <div class="dd-red-text">
        <dd-get-directions [dealerDetails]="dealerDetails" (click)="omTag.fireOmnitureTag('vd_aa-link_download', {url:$event.srcElement.href, href: $event.srcElement.href, text:$event.srcElement.innerText, trigger:'aa-link'}, sharedData)"></dd-get-directions>
      </div>
      <div fxLayout="row">
        &nbsp;
      </div>
      <div fxLayout="row">
        &nbsp;
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="dd-content-margin" style="padding-bottom: 3%;padding-top: 2%;">
      <div class="dd-disclaimer" *ngIf="dealerDetails?.isLexus">
        * {{vehicleDetails?.year}} Manufacturer’s Suggested Retail Price, excludes the Delivery, Processing and
        Handling Fee, taxes,
        license, title and available or regionally required equipment. Actual Dealer price may vary. Pricing,
        specifications, fuel economy, standard features and available equipment are based on information available when this
        page
        was produced and subject to change without notice.
      </div>
      <div *ngIf="!dealerDetails?.isLexus" class="dd-disclaimer">
        <span *ngIf="baseMsrpDisclaimer">
          * {{ baseMsrpDisclaimer }}
        </span>
      </div>
      <!-- <div *ngIf="!(isSmartPathDealer || isGST) && !dealerDetails?.isLexus" class="dd-disclaimer">
        {{ tsrpDisclaimer }}
      </div> -->
      <div class="dd-disclaimer" *ngIf="!dealerDetails?.isLexus">
        ToyotaCare, which covers normal factory scheduled maintenance for 2 years or 25,000 miles,
        whichever comes first, is included as part of the sales price of the vehicle for qualifying buyers.
        See participating dealer for eligibility and coverage details.
       </div>
       <br>
      <div class="dd-disclaimer">
        Disclaimer: This document is not meant to replace or substitute the actual window sticker on the vehicle. 
        Toyota Motor Sales, U.S.A., Inc. is not responsible and disclaims any liability for inaccuracies. 
        Please contact your dealer with any questions or if you require additional information.
      </div>
    </div>
  </div>
</div>


<ng-container *ngIf="vehicleDetails?.dealerCategory === 'H'">
  <div class="dd-sold-vehicle">
  VIN  &nbsp;<span class="vin-sold">{{vehicleDetails?.vin}}</span> &nbsp; has been reported sold and/or is no longer in inventory. Please contact the dealer for additional information.
</div>
</ng-container>
